import React, { useState } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { isEmpty, cengoldAlert } from "lib/utils";
import { CengoldModal } from "../../components/CengoldModal";

import { TradeHistoryItem, BtnMore } from "pages";

import { btn_more, icon_notice_n } from "styles/img";
import { Message } from "constants/index";

SwiperCore.use([Navigation]);

const TradeHistory = ({ histories }) => {
  const historyPegMap = [];
  const historyPesMap = [];
  let index = 0;
  if (histories !== null && !isEmpty(histories)) {
    if (histories.peg.length > 0) {
      histories.peg.forEach((history) => {
        historyPegMap.push(
          <ul key={index} className="td">
            <TradeHistoryItem key={index} item={history} />
          </ul>
        );
        index++;
      });
    }
    if (histories.pes.length > 0) {
      histories.pes.forEach((history) => {
        historyPesMap.push(
          <ul key={index} className="td">
            <TradeHistoryItem key={index} item={history} />
          </ul>
        );
        index++;
      });
    }
  }

  const [showSellModal, setShowSellModal] = useState(false);
  const onCloseModal = () => {
    setShowSellModal(false);
  };

  return (
    <div className="section">
      <div className="content">
        <div className="detail_wrap">
          <div className="top">
            <h3 className="tit" style={{ marginBottom: "-30px" }}>
              거래내역
            </h3>
          </div>
          <div className="both"></div>

          <div className="trade-history-swiper-wrapper">
            <Swiper
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
            >
              <SwiperSlide>
                {historyPegMap.length > 0 && (
                  <div className="table">
                    <ul className="th">
                      <li>
                        <div className="th01">거래일자/구분</div>
                        <div className="th02">수량</div>
                        <div className="th03">잔고</div>
                      </li>
                    </ul>
                    {historyPegMap}
                  </div>
                )}
                {historyPegMap.length === 0 && (
                  <div className="content_none">
                    <img src={icon_notice_n} alt="icon" />
                    <p>거래내역이 없습니다.</p>
                  </div>
                )}
              </SwiperSlide>
              <SwiperSlide>
                {historyPesMap.length > 0 && (
                  <div className="table">
                    <ul className="th">
                      <li>
                        <div className="th01">거래일자/구분</div>
                        <div className="th02">수량</div>
                        <div className="th03">잔고</div>
                      </li>
                    </ul>
                    {historyPesMap}
                  </div>
                )}
                {historyPesMap.length === 0 && (
                  <div className="content_none">
                    <img src={icon_notice_n} alt="icon" />
                    <p>거래내역이 없습니다.</p>
                  </div>
                )}
              </SwiperSlide>
              <div slot="container-end" className="swiper-button-next"></div>
              <div slot="container-end" className="swiper-button-prev"></div>
            </Swiper>
          </div>
          <BtnMore
            className="btn_more apply_btn3"
            txt="거래내역 상세보기"
            imgSrc={btn_more}
            onClick={() => {
              setShowSellModal(true);
            }}
          />
        </div>
      </div>
      <CengoldModal
        visible={showSellModal}
        title={"거래내역 상세보기"}
        onClose={onCloseModal}
      >
        <div>거래내역은 최근 5건의 거래내역</div>
        <div>정보를 제공합니다.</div>
        <div>보다 상세한 거래내역은 비단앱에서</div>
        <div>확인하실 수 있습니다.</div>
      </CengoldModal>
    </div>
  );
};

export default TradeHistory;
